/* 孫吳傳・第 3 章：梁東突圍（初平二年，191）
 * 史實：《三國志·孫堅傳》「堅移屯梁東，大爲卓軍所攻，堅與數十騎潰圍而出。堅常著赤罽幘，乃脫幘令親近將祖茂著之。
 *       卓騎爭逐茂，故堅從間道得免。茂困迫，下馬，以幘冠冢間燒柱，因伏草中。卓騎望見，圍繞數重，定近覺是柱，乃去。」
 * 流程：夜裡被徐榮三面圍住，往西殺出一條路 → 把赤幘交給祖茂，追兵改追祖茂，孫堅從西南的間道撤 →
 *       祖茂在冢間把赤幘掛在燒過的柱子上、躲進草裡，追兵圍著柱子繞了幾圈才發現是柱子，散去 →
 *       （額外）回頭到冢間接祖茂 → 到西南的安全處即勝利。
 * 追兵追祖茂時，孫堅走近（250 內）他們還是會打孫堅。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, TROOPS, PEOPLE, vanish, rout } from '../kit.ts';

const CAMP = [4900, 2800], GAP = [2700, 2800], GRAVE = [1700, 1250], PILLAR = [1760, 1230], HIDE = [1500, 1050], SAFE = [800, 4700];
const LV = 7;
const FOE = { spec: TROOPS.dong, name: '涼州兵', hp: 440, maxHp: 440, atk: 24, ms: 255 };

export default {
  id: 'sunwu-3', map: 'liangdong', hero: 'sunjian',
  title: '第 2 章　梁東突圍', year: '初平二年（191）',
  brief: {
    quote: [{ text: '堅移屯梁東，大爲卓軍所攻，堅與數十騎潰圍而出。', src: '《三國志·吳書·孫堅傳》' }],
    text: '關東諸侯起兵討董卓，孫堅從魯陽北上。移屯梁東時，董卓的部將徐榮率大軍夜襲，三面合圍。',
    goals: ['往西殺出重圍', '把赤幘交給祖茂，從間道撤走', '（額外）回頭接應祖茂'],
  },
  words: { ally: '親騎', foe: '涼州兵' },
  stars: [
    { text: '祖茂生還，一起撤離', ok: (m) => !!m.vars.withZu },
    { text: '親騎折損不超過 2 人', ok: (m) => m.stats.lost <= 2 },
    { text: '從間道撤走時沒有被追上（交出赤幘後沒受傷）', ok: (m) => !m.vars.caught },
  ],
  steps: [
    { // 1. 三面合圍：往西殺出一條路
      enter(m, w) {
        const me = w.player;
        me.x = CAMP[0] - 200; me.y = CAMP[1];
        setLevel(w, me, LV);
        m.vars.riders = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(me.x + 60 + (i % 4) * 45, me.y - 60 + Math.floor(i / 4) * 80, '親騎'); m.join(u, me); return u; });
        const zu = ally(w, PEOPLE.zumao, me.x + 80, me.y + 100, LV);
        zu.name = '祖茂'; m.vars.zu = zu;
        const ring = (cx, cy, n, sx, sy) => Array.from({ length: n }, (_, i) => m.foe('huangjin', cx + (i % 5) * sx - 2 * sx, cy + Math.floor(i / 5) * sy, FOE));
        const sides = [].concat(ring(4900, 1500, 10, 120, 140), ring(4900, 3900, 10, 120, 140), ring(6300, 2600, 10, 110, 150));
        for (const u of sides) u.home = [CAMP[0] + (u.x - CAMP[0]) * 0.55, CAMP[1] + (u.y - CAMP[1]) * 0.55]; // 北、東、南三面一路收攏
        const west = Array.from({ length: 9 }, (_, i) => m.foe(i < 2 ? 'bandit' : 'huangjin', 3400 + (i % 3) * 70, 2620 + Math.floor(i / 3) * 130, i < 2 ? { spec: TROOPS.dong, name: '涼州校尉' } : FOE)); // 西邊的攔截：守在大路上不動
        m.vars.foes = sides.concat(west); m.vars.west = west;
        m.gate('line', 3330, 2780, 460); // 西邊的敵陣：攔截兵還在，就衝不過去
        m.vars.xu = boss(w, PEOPLE.xurong, 6400, 2800, { hp: 5200, atk: 70, armor: 8, name: '徐榮', ms: 215 });
        m.vars.xu.home = [5600, 2800];
        m.card('大爲卓軍所攻。', '《孫堅傳》');
        m.line('孫堅', '徐榮夜襲！北、東、南都是敵兵——西邊最薄，往西殺出去！');
        m.mark('gap', GAP[0], GAP[1], '突圍');
        m.obj('gap', '往西殺出重圍');
        m.after(6, () => m.i === 0 && m.line('提示', `孫堅現在 ${me.lv} 級。徐榮很強，不要戀戰，打開西邊的缺口就走。`));
      },
      tick(m, w) {
        if (m.gates.length && m.alive(m.vars.west).length <= 2) { m.ungate('line'); m.line('孫堅', '缺口開了！衝出去！'); }
        const xu = m.vars.xu; if (xu.alive && !xu.target) xu.home = [w.player.x, w.player.y]; // 徐榮親自追來：停下來戀戰就會被追上
        return m.near(w.player, GAP[0], GAP[1], 260);
      },
    },
    { // 2. 脫幘：赤幘交給祖茂，追兵改追他；孫堅從西南的間道走
      enter(m, w) {
        const me = w.player, zu = m.vars.zu;
        m.done('gap'); m.unmark('gap');
        m.card('堅常著赤罽幘，乃脫幘令親近將祖茂著之。', '《孫堅傳》');
        m.line('孫堅', '祖茂，戴上我的赤幘，往西北引開他們！');
        m.after(2, () => m.line('祖茂', '主公快走！卓騎交給我！'));
        zu.x = me.x - 60; zu.y = me.y - 80;
        zu.redCap = true; zu.hold = null;
        w.addBuff(zu, { id: '赤幘', t: 9999, ms: 0.25 });
        me.redCap = false; m.vars.cap = true;
        m.vars.hp0 = me.hp;
        m.mark('safe', SAFE[0], SAFE[1], '間道出口');
        m.mark('zu', zu.x, zu.y, '祖茂', true, zu);
        m.obj('safe', '從西南的間道撤到安全的地方');
        // 追兵：所有還活著的涼州兵都去追戴赤幘的人
        for (const u of m.alive(m.vars.foes)) { u.chase = true; u.target = null; u.ms = 270; }
        m.vars.xu.home = [3600, 2600];
      },
      tick(m, w) {
        const me = w.player, zu = m.vars.zu, V = m.vars;
        if (me.hp < V.hp0 - 1 && !V.caught) { V.caught = true; m.line('孫堅', '被追兵咬上了……快甩開他們！'); }
        V.hp0 = me.hp;
        // 祖茂：往冢間跑；到了就把赤幘掛到燒過的柱子上，躲進草裡
        if (!V.hung && zu.alive) {
          zu.input.moveTo = GRAVE.slice(); zu.input.target = null;
          if (SG.gd(zu.x, zu.y, GRAVE[0], GRAVE[1]) < 120) {
            V.hung = w.t; zu.redCap = false;
            zu.x = HIDE[0]; zu.y = HIDE[1]; zu.untargetable = true; zu.input = {}; zu.hold = HIDE.slice();
            m.folk(PILLAR[0], PILLAR[1], { name: '燒柱', still: true, near: 1, draw: pillar });
            m.card('茂困迫，下馬，以幘冠冢間燒柱，因伏草中。', '《孫堅傳》');
          }
        }
        // 追兵：追赤幘（祖茂身上或柱子上）；孫堅走近 250 照樣打他
        const cap = V.hung ? PILLAR : zu.alive ? [zu.x, zu.y] : null;
        for (const u of m.alive(V.foes)) {
          if (!u.chase) continue;
          if (SG.gd(u.x, u.y, me.x, me.y) < 250) { u.home = [me.x, me.y]; continue; }
          u.target = null; u.think = 0.35;
          if (cap) { const a = (u.id * 1.7) % (Math.PI * 2), r = V.hung ? 160 + (u.id % 3) * 60 : 40; u.home = [cap[0] + Math.cos(a + w.t * 0.6) * r, cap[1] + Math.sin(a + w.t * 0.6) * r * 0.7]; }
        }
        // 圍著柱子繞了十二秒：發現是柱子，散去
        if (V.hung && !V.gone && w.t - V.hung > 12) {
          V.gone = true;
          m.card('卓騎望見，圍繞數重，定近覺是柱，乃去。', '《孫堅傳》');
          rout(m, w, V.foes.filter((u) => u.chase), [7400, 2800]);
          vanish(w, V.xu);
          zu.untargetable = false;
          m.after(2, () => { m.line('祖茂', '……他們走了。主公還在附近嗎？'); m.obj('zu', '（額外）回冢間接應祖茂'); m.mark('zuhide', HIDE[0], HIDE[1], '祖茂'); });
        }
        if (V.gone && !V.withZu && zu.alive && m.near(me, HIDE[0], HIDE[1], 220)) {
          V.withZu = true; m.done('zu'); m.unmark('zuhide');
          zu.hold = null; m.line('祖茂', '主公！祖茂還活著！'); m.line('孫堅', '好兄弟，一起走！');
        }
        if (!zu.alive && !V.zuDead) { V.zuDead = true; m.unmark('zu'); m.line('孫堅', '祖茂……'); }
        if (!m.near(me, SAFE[0], SAFE[1], 260)) return false;
        m.done('safe');
        m.card('故堅從間道得免。', '《孫堅傳》');
        m.after(2.5, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('孫堅陣亡'); return; }
    const zu = m.vars.zu;
    if (zu && (!m.vars.cap || m.vars.withZu)) allyTick(w, zu, w.player, 420);
  },
};

// 冢間的燒柱：焦黑的木柱，頂上掛著紅色的赤幘
function pillar(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 22, 7, 100, 0.3);
  poly(ctx, [[-9, 0], [9, 0], [7, -96], [-7, -96]], '#2a2420', 1.8);
  ctx.fillStyle = 'rgba(255,120,40,.35)'; ctx.fillRect(-6, -60, 4, 10);
  poly(ctx, [[-14, -96], [14, -96], [10, -112], [-10, -112]], '#c0302a', 1.8); // 赤幘
  poly(ctx, [[10, -100], [26, -88 + Math.sin(T * 3) * 3], [12, -96]], '#c0302a', 1.2);
  ctx.restore();
}
